import React, { useState } from "react";
import { Formik, Field, } from "formik";
import { Button } from "react-bootstrap";
import {
    Select,
} from "../../_metronic/_partials/controls";
import SearchSelectInput from "./SelectComponents/SearchSelectInput";
// import { useSubheader } from "../../_metronic/layout";

const FilterComponent = (props) => {
    const [frmInitialValues, setFrmInitialValues] = useState({ q: '', });
    const [open, setOpen] = useState(false);
    // const suhbeader = useSubheader();
    const applyFilter = (values) => {
        props.filterChange(values);
    }
    const selectChange = (values, name, value, setFieldValue, handleSubmit) => {
        setFieldValue(name, value);
        // props.filterChange(values);
        handleSubmit();
    }
    return (
        <>
            {props.isShowSidebar && (
                <>
                    <Button onClick={() => setOpen(true)} className={'ml-3'} type="primary" >Filter</Button>
                    <div id="kt_quick_filter" className={`offcanvas filter-offcanvas offcanvas-right offcanvas  ${open ? 'offcanvas-on' : ''}`} >
                        <div className="offcanvas-header border-bottom d-flex align-items-center justify-content-between p-5">
                            <h3 className="font-weight-bold m-0">
                                Filter
                            </h3>
                            <button
                                type="button"
                                className="btn btn-xs btn-icon btn-light btn-hover-primary"
                                onClick={() => setOpen(false)}
                            >
                                <i className="ki ki-close icon-xs text-muted" />
                            </button>
                        </div>
                        <div className="offcanvas-content pt-7 pl-10 pr-10 filter-body">
                            <div className="d-flex gutter-b">
                                <Formik
                                    initialValues={frmInitialValues}
                                    onSubmit={(values) => {
                                        applyFilter(values);
                                    }}
                                >
                                    {({
                                        handleSubmit,
                                        handleBlur,
                                        handleChange,
                                        setFieldValue,
                                        values,
                                    }) => (
                                        <form onSubmit={handleSubmit} className="form form-filter w-100" autoComplete="off">
                                            <div className="form-group row">
                                                {props.columns && props.columns.length > 0 && (
                                                    props.columns.map(item =>
                                                        <>
                                                            {item.type === 'searchselect' && (
                                                                <div className="col-6">
                                                                    <div className="filter-label">{item.label}</div>
                                                                    <Field
                                                                        name={item.dataField}
                                                                        component={SearchSelectInput}
                                                                        source={item.sorce}
                                                                    />
                                                                </div>
                                                            )}
                                                            {item.type === 'radio' && (
                                                                <div className="col-6">
                                                                    <div role="group" aria-labelledby="my-radio-group" className="radio-inline">
                                                                        <div className="filter-label">{item.label}</div>
                                                                        {item.options && item.options.map(option =>
                                                                            <label className="radio">
                                                                                <Field type="radio" name={`filter[${item.dataField}]`} value={option.value} />
                                                                                <span></span>{option.name}
                                                                            </label>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {item.type === 'select' && (
                                                                <div className="col-6">
                                                                    <div className="filter-label">{item.label}</div>
                                                                    <Select name={`filter[${item.dataField}]`}
                                                                        onChange={(e) => selectChange(values, `filter[${item.dataField}]`, e.target.value, setFieldValue, handleSubmit)}
                                                                    >
                                                                        <option value={''}>All</option>
                                                                        {item.options && item.options.map(option =>
                                                                            <option value={option.value}>{option.name}</option>
                                                                        )}
                                                                    </Select>
                                                                </div>
                                                            )}
                                                        </>
                                                    )
                                                )}
                                            </div>
                                        </form>
                                    )}
                                </Formik>

                            </div>
                        </div>
                    </div>
                </>
            )}
            {!props.isShowSidebar && (
                <Formik
                    initialValues={frmInitialValues}
                    onSubmit={(values) => {
                        applyFilter(values);
                    }}
                >
                    {({
                        handleSubmit,
                        handleBlur,
                        handleChange,
                        setFieldValue,
                        values,
                    }) => (
                        <form onSubmit={handleSubmit} className="form form-label-right" autoComplete="off">
                            <div className="form-group row">
                                {/* <div className="bg-white border col-md-4 d-flex flex-center px-6 py-2 rounded">
                                    <span className="svg-icon svg-icon-lg svg-icon-primary">
                                    <SVG src={toAbsoluteUrl( "/media/svg/icons/General/Search.svg")}/>
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control border-0 font-weight-bold pl-2"
                                        name="q"
                                        placeholder="Search"
                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                            setFieldValue("q", e.target.value);
                                        }}
                                    />
                                </div> */}
                                <div className="col-lg-2">
                                    {props.filterData && props.filterData.length > 0 && (
                                        props.filterData.map(item =>
                                            <>
                                                {item.type === 'select' && (
                                                    <Select name={`filter[${item.name}]`}
                                                        onChange={(e) => selectChange(values, `filter[${item.name}]`, e.target.value, setFieldValue, handleSubmit)}
                                                    >
                                                        <option value={''}>All</option>
                                                        {item.options && item.options.map(option =>
                                                            <option value={option.value}>{option.name}</option>
                                                        )}
                                                    </Select>
                                                )}
                                            </>
                                        )
                                    )}
                                </div>
                            </div>
                        </form>
                    )}
                </Formik>
            )
            }
        </>
    )
}
export default FilterComponent;